import { Box, Grid, Typography } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Anchors } from "../../constants/routes";
import { GoogleServicesContext } from "../../context/GoogleServicesContext";
import siteImages from "../../data/siteImages";
import { gaAction, gaCategory } from "../../utils/analytics";
import { smoothScroll } from "../../utils/utilities";
import Button, { ButtonVariant } from "../utils/Button";

const Intro = () => {
  const { t } = useTranslation();
  const { analyticsEvent } = useContext(GoogleServicesContext);

  const title = t("home.intro.title");
  const subtitle = t("home.intro.subtitle");
  const description = t("home.intro.description");
  const introImages = siteImages.introImages;

  return (
    <Grid
      container
      spacing={8}
      sx={{
        p: { xs: 5, md: 7 }
      }}>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center"
        }}>
        <Typography variant="h2" component="h1" fontWeight="bold" mb={1}>
          {title}
        </Typography>
        <Typography variant="h4" component="p" fontStyle="italic" mb={5}>
          {subtitle}
        </Typography>
        <Typography
          variant="body2"
          sx={{ maxWidth: { xs: "100%", md: "60%" }, mb: 5, textAlign: "center" }}>
          {description}
        </Typography>

        <Box sx={{ flexGrow: 1, display: "flex", alignItems: "flex-end" }}>
          <Button
            variant={ButtonVariant.secondary}
            label={t("buttons.aboutUs")}
            onClick={() => {
              smoothScroll(Anchors.aboutUs);
              analyticsEvent(gaCategory.aboutUs, gaAction.click, Anchors.aboutUs);
            }}
          />
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={(theme) => ({
          position: "relative",
          height: { xs: theme.spacing(60), md: theme.spacing(80) },
          "&:hover > img": {
            transform: `scale(1.2)`
          },
          "&:hover > #tile-0": {
            transform: `rotate(-15deg) scale(1.2)`
          },
          "&:hover > #tile-2": {
            transform: `rotate(15deg) scale(1.2)`
          }
        })}>
        {introImages.length === 3 &&
          introImages.map((image, index) => (
            <Box
              id={`tile-${index}`}
              key={index}
              component="img"
              src={image.src}
              alt={image.alt}
              sx={(theme) => ({
                height: { xs: theme.spacing(40), md: theme.spacing(50) },
                position: "absolute",
                left: index === 0 ? "30%" : index === 1 ? "40%" : "50%",
                top: index === 0 ? "30%" : index === 1 ? "25%" : "20%",
                transform: index === 0 ? "rotate(-10deg)" : index === 1 ? "none" : "rotate(10deg)",
                boxShadow: "5px 5px 4px 0px rgba(0, 0, 0, 0.25)",
                transition: "all 0.4s ease-in-out",
                cursor: "pointer"
              })}
            />
          ))}
      </Grid>
    </Grid>
  );
};

export default Intro;
